import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import apiClient from "../../services/apiClient";
import SEO from "../../components/SEO";
import {
  getApproachabilityLabel,
  getQualificationStatusLabel,
} from "../constants/prospectLabels";

export default function AdminProspectsWhyNotPage() {
  const [data, setData] = useState({ reasons: [], rows: [] });

  useEffect(() => {
    apiClient.adminProspectsWhyNot().then(setData);
  }, []);

  return (
    <>
      <SEO title="Pourquoi certains prospects sont exclus | DigiBuddy" noIndex noFollow />
      <Typography variant="h4" sx={{ mb: 2 }}>
        Pourquoi certains resultats ne sont pas de vrais prospects
      </Typography>

      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Motifs principaux
        </Typography>
        {(data.reasons || []).map((item) => (
          <Typography key={item.reason} variant="body2">
            {item.reason}: {item.count}
          </Typography>
        ))}
      </Paper>

      <Paper sx={{ overflow: "auto" }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Entreprise</TableCell>
              <TableCell>Score</TableCell>
              <TableCell>Statut</TableCell>
              <TableCell>Approchabilite</TableCell>
              <TableCell>Raison</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(data.rows || []).map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.company_name}</TableCell>
                <TableCell>{row.global_score}</TableCell>
                <TableCell>{getQualificationStatusLabel(row.qualification_status)}</TableCell>
                <TableCell>{getApproachabilityLabel(row.approachability_label)}</TableCell>
                <TableCell>{row.exclusion_reason || "Enrichissement requis"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
      <Box sx={{ mt: 1 }}>
        <Typography variant="body2" color="text.secondary">
          {data.total || 0} ligne(s)
        </Typography>
      </Box>
    </>
  );
}
